import { NgModule } from '@angular/core';

import { provideState, StoreModule } from '@ngrx/store';

import {
  CountryDataNamespace,
  CountryDataReducer,
  countryStoreConfigFactory,
  COUNTRY_STORE_CONFIG,
} from './store/country.store';

@NgModule({
  imports: [StoreModule.forFeature(CountryDataNamespace, CountryDataReducer, COUNTRY_STORE_CONFIG)],
  providers: [
    {
      provide: COUNTRY_STORE_CONFIG,
      useFactory: countryStoreConfigFactory,
    },
  ],
})
export class CountryDataModule {}

const provideCountriesDataState = provideState(
  CountryDataNamespace,
  CountryDataReducer,
  COUNTRY_STORE_CONFIG,
);
export const countriesData = [provideCountriesDataState];
